import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Routes from './pages/Routes';
import ReactI18nProvider from './providers/ReactI18nProvider';
import ConfirmDialog from './components/ConfirmDialog';
import SnackBarProvider from './providers/SnackBarProvider';
import FeatureContextProvider from './context/FeatureFlagContext';

const App = () => {
  return (
    <Provider store={store}>
      <FeatureContextProvider>
        <SnackBarProvider>
          <ReactI18nProvider>
            <BrowserRouter>
              <ConfirmDialog />
              <Routes />
            </BrowserRouter>
          </ReactI18nProvider>
        </SnackBarProvider>
      </FeatureContextProvider>
    </Provider>
  );
};

export default App;
